import { Component, Input } from '@angular/core';

interface RangeMap {
  color: string;
  char: string;
  score?: number;
}

@Component({
  selector: 'app-sentiment-score',
  templateUrl: './sentiment-score.component.html',
  styleUrls: ['./sentiment-score.component.scss'],
})
export class SentimentScoreComponent {
  @Input() score: number;
  public range: RangeMap[] = [
    { char: '&#128544;', color: '#e40513' },
    { char: '&#128530;', color: '#fe9308' },
    { char: '&#128528;', color: '#ffd100' },
    { char: '&#128524;', color: '#bceb01' },
    { char: '&#128525;', color: '#28a738' },
  ];

  public scoreIndex: number;

  ngOnInit(): void {
    if (this.score >= 0) {
      const score = Math.round(this.range.length * (this.score / 100)) - 1;
      if (score < 0) {
        this.scoreIndex = 0;
      } else if (score > this.range.length - 1) {
        this.scoreIndex = this.range.length - 1;
      } else {
        this.scoreIndex = score;
      }
      this.range[this.scoreIndex].score = this.score;
    }
  }
}
